import Vue from 'vue'
import Vuex from 'vuex'
// 挂载Vuex
Vue.use(Vuex)
// 创建VueX对象
const store = new Vuex.Store({
    state: {
        partnerId: window.E.partnerId,
        accountNum: window.E.accountNum
    },
    getters: {
        getPartnerId (state) {
            console.log('state-getters', state)
            if (window.E.partnerId) {
                state.partnerId = window.E.partnerId
            }
            return state.partnerId
        },
        getAccountNum (state) {
            console.log('state-getters-getAccountNum', state)
            if (window.E.accountNum) {
                state.accountNum = window.E.accountNum
            }
            return state.accountNum
        }
    },
    mutations: {
        setPartnerId (state) {
            console.log('setPartnerId state', state)
            state.partnerId = window.E.partnerId
        },
        setAccountNum (state) {
            console.log('setAccountNum state', state, window.E.accountNum)
            state.accountNum = window.E.accountNum
        }
    }
})
export default store
